// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__Ifys1","inputWrap":"CustomTip_inputWrap__1LPte"};